import React from 'react';

const Sponsors: React.FC = () => {
  return (
    <section className="text-white p-10 text-center">
      <h2 className="text-4xl font-bold">Sponsors</h2>
      <p className="text-xl mt-4">We are looking for sponsors to help us make this event a success. If you are interested in sponsoring, please contact us at <a className='text-blue-400' href='mailto:hello@hack-chicago.org'>hello@hack-chicago.org</a></p>
    </section>
  );
};

export default Sponsors;